import { formatTime } from './formatTime';

/**
 * 日付文字列と時間文字列を結合する。
 * @param dateStr string
 * @param timeStr string
 * @param joint string
 * @returns string | undefined
 */
export const joinDateStringAndTimeString = (
  dateStr?: string,
  timeStr?: string,
  joint = ' '
) => {
  if (!dateStr || !timeStr) {
    return undefined;
  }
  return `${dateStr}${joint}${formatTime(timeStr)}`;
};
